import { NotificationTypes } from '@vantiva-sa/homesight_humaui/Utilities/Constants';
import moment from 'moment';

const ONGOING_MEETING_DISPLAY_TIME_HOURS = 4;

export const processScheduleNotification = (scheduleList, loginUserTimeformat) => {
  const is24hoursformat = loginUserTimeformat?.is24hoursformat;
  let now = moment();
  const filteredList = scheduleList.filter((event) => {
    let time = moment(event.display_event_time, 'HH:mm:ss', is24hoursformat);
    let tillTime = moment().subtract(ONGOING_MEETING_DISPLAY_TIME_HOURS, 'hour');
    return (
      'display_event_date' in event &&
      event.display_event_date === now.format('YYYY-MM-DD') &&
      time.isAfter(tillTime)
    );
  });

  let processedList = [];
  filteredList.forEach((event) => {
    let eventInfo = {
      key: event.schedule_eventuuid,
      type: NotificationTypes.scheduledEvent,
      datetime: 'Today, ',
      description_row_1: 'Event reminder',
      description_row_2: event.event_name,
      status: null,
      display_event_time: event.display_event_time,
      otherUserInfo: event,
    };
    if ('display_event_time' in event) {
      let dateTime = moment(event.display_event_time, 'HH:mm:ss', is24hoursformat);
      eventInfo.datetime =
        eventInfo.datetime + dateTime.format(is24hoursformat ? 'HH:mm' : 'h:mm A');
    } else if ('event_timestamp' in event) {
      let dateTime = moment(+event.event_timestamp, is24hoursformat);
      eventInfo.datetime =
        eventInfo.datetime + dateTime.format(is24hoursformat ? 'HH:mm' : 'h:mm A');
    } else {
      let time = moment(event.event_time, 'HH:mm', is24hoursformat);
      time.add(time.utcOffset(), 'minutes', is24hoursformat);
      eventInfo.datetime = eventInfo.datetime + time.format(is24hoursformat ? 'HH:mm' : 'h:mm A');
    }
    processedList.push(eventInfo);
  });
  return processedList;
};
